import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import '@scss/page_login.scss';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import SchoolIcon from '@material-ui/icons/School';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {cloneDeep} from 'lodash';
import PageAuthLoginContainer from './PageAuthLoginContainer';
import PageAuthRegistrationContainer from './PageAuthRegistrationContainer';
import PageAuthRegisteredContainer from './PageAuthRegisteredContainer';
import PageAuthForgotPasswordContainer from './PageAuthForgotPasswordContainer';
import PageAuthResetPasswordContainer from './PageAuthResetPasswordContainer';
import PageAuthSendResetPasswordLinkContainer from './PageAuthSendResetPasswordLinkContainer';
import PageAuthResetedPasswordContainer from './PageAuthResetedPasswordContainer';
import {HashRouter, Route, Switch} from 'react-router-dom';
import {withTranslation} from "react-i18next";
import LanguageSwitcher from "../ui/LanguageSwitcher";

const styles = theme => ({
    themeDirection: theme.direction,
    h4: {
        fontWeight: 'bold',
    },
    loginBtn: {
        backgroundColor: '#009be5',
        width: '100%',
        padding: '15px 0px',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: '#0082c0',
        }
    },
});

class PageAuthContainer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {classes, vuzName, t, i18n} = this.props;
        return(
            <Grid container spacing={0} alignItems="center" justifyContent="center" className="page-login-container">
                <Grid item xs={10} sm={6} className="page-login-form-wrapper">
                    <Grid container spacing={0}>
                        <Grid item xs={12} className="page-login-form-header">
                            <Typography variant="h4" className={classes.h4}>
                                {t('lk_abitur')}
                                <Grid container justifyContent="flex-end" alignItems="center">
                                    <LanguageSwitcher/>
                                </Grid>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} className="page-login-form-body">
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <div className="organization-name-wrapper">
                                        <div className="organization-name-icon-wrapper">
                                            <SchoolIcon/>
                                        </div>
                                        <div className="organization-name">
                                            <Typography variant="h5" className="organization-name">{vuzName}</Typography>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <HashRouter>
                                        <Switch>
                                            <Route exact path="/" component={PageAuthLoginContainer} />
                                            <Route path="/registration" component={PageAuthRegistrationContainer} />
                                            <Route path="/registered" component={PageAuthRegisteredContainer} />
                                            <Route path="/forgot-password" component={PageAuthForgotPasswordContainer} />
                                            <Route path="/reset-password" component={PageAuthResetPasswordContainer} />
                                            <Route path="/send-link-reset-password" component={PageAuthSendResetPasswordLinkContainer} />
                                            <Route path="/reseted-password" component={PageAuthResetedPasswordContainer} />
                                        </Switch>
                                    </HashRouter>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="back-button">
                                        <Button color="inherit" href="/abitur">
                                            <KeyboardBackspaceIcon/>&nbsp;{t('back_to_site')}
                                        </Button>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="body2" align="center">
                                        {i18n.language === "en"
                                            ? <>
                                                The personal account was created using the
                                                &nbsp;
                                                <Link href="https://db-nica.ru" target="_blank">VIKON</Link>
                                                &nbsp;
                                                software and methodological complex.
                                            </>
                                            : <>
                                                Личный кабинет создан при помощи программно-методического комплекса
                                                &nbsp;
                                                <Link href="https://db-nica.ru" target="_blank">
                                                    VIKON
                                                </Link>
                                            </>
                                        }
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        vuzName: cloneDeep(state.vuzName),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(PageAuthContainer));
